import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PremiumOverlayComponent} from './premium-overlay.component';
import {IconModule} from '@tisa-group/client-ui/components/icon';
import {TISA_SIGN_IN_URL_PROVIDERS} from './premium-overlay.providers';
import {RouterModule} from '@angular/router';
import {TISA_DEFAULT_PREMIUM_OVERLAY_PROVIDERS} from '@tisa-group/client-ui/tokens/premium-overlay-component';

@NgModule({
  declarations: [PremiumOverlayComponent],
  exports: [PremiumOverlayComponent],
  imports: [CommonModule, IconModule, RouterModule],
  providers: [TISA_SIGN_IN_URL_PROVIDERS, TISA_DEFAULT_PREMIUM_OVERLAY_PROVIDERS],
})
export class PremiumOverlayModule {}
